enum BaseRoutes {
  ROOT = '/',
  LOGIN = '/log-in',
  PASSWORD_RESET = '/password-reset',
  SIGNUP = '/sign-up',
  REDIRECT = '/redirect',
  INVITATION = '/invitation/:id',
  MAIN = '/main',
  EXCEPTION = '*',
}

enum MainRoutes {
  DASHBOARD = 'dashboard',
  AVAILABILITY = 'availability',
  FLEET = 'fleet',
  DRIVERS = 'drivers',
  PRICING = 'pricing',
  MESSAGES = 'messages',
  LOGISTICS = 'logistics',
  OFFERS = 'offers',
  ALERTS = 'alerts',
  DOCUMENTATION = 'documentation',
  LANGUAGE = 'language',
  SETTINGS = 'settings',
  B2B = 'b2b',
  ORDERS = 'orders',
  LOGOUT = 'logout',
}

enum AvailabilityRoutes {
  BUS = 'bus',
  DRIVER = 'driver',
}

enum FleetRoutes {
  LOCATION = 'location',
  DOCUMENTS = 'documents',
  REPAIR = 'repair',
}

enum DriversRoutes {
  DOCUMENTS = 'documents',
  VACATION = 'vacation',
}

enum LogisticsRoutes {
  ALL_RIDES = 'all-rides',
  MAP = 'map',
}

enum PricingRoutes {
  PERIOD = 'period',
  COST = 'cost',
}

enum B2BRoutes {
  MY_CLIENTS = 'my-clients',
  ALL_CLIENTS = 'all-clients',
}

enum AlertsRoutes {
  CURRENT = 'current',
  HISTORY = 'history',
}

enum MessagesRoutes {
  HISTORY = 'history',
  GROUP = 'group',
}

enum SettingsRoutes {
  ACCOUNT = 'account',
  SUBSCRIPTION = 'subscription',
  COMPANY = 'company',
  USERS = 'users',
  CONFIGURATION = 'configuration',
}

enum LanguageRoutes {
  LANGUAGE_ET = 'language_et',
  LANGUAGE_EN = 'language_en',
  LANGUAGE_LV = 'language_lv',
  LANGUAGE_RU = 'language_ru',
}

export const ROUTES = {
  BaseRoutes,
  MainRoutes,
  AvailabilityRoutes,
  FleetRoutes,
  DriversRoutes,
  LogisticsRoutes,
  PricingRoutes,
  AlertsRoutes,
  MessagesRoutes,
  SettingsRoutes,
  B2BRoutes,
  LanguageRoutes,
};

const BASE_KEYS = Object.values(ROUTES.BaseRoutes);
const MAIN_KEYS = Object.values(ROUTES.MainRoutes);
const AVAILABILITY_KEYS = Object.values(ROUTES.AvailabilityRoutes);
const FLEET_KEYS = Object.values(ROUTES.FleetRoutes);
const DRIVERS_KEYS = Object.values(ROUTES.DriversRoutes);
const LOGISTICS_KEYS = Object.values(ROUTES.LogisticsRoutes);
const PRICING_KEYS = Object.values(ROUTES.PricingRoutes);
const ALERTS_KEYS = Object.values(ROUTES.AlertsRoutes);
const MESSAGES_KEYS = Object.values(ROUTES.MessagesRoutes);
const SETTINGS_KEYS = Object.values(ROUTES.SettingsRoutes);
const B2B_KEYS = Object.values(ROUTES.B2BRoutes);
const LANGUAGE_KEYS = Object.values(ROUTES.LanguageRoutes);

export type RouteItemKey =
  | (typeof BASE_KEYS)[number]
  | (typeof MAIN_KEYS)[number]
  | (typeof AVAILABILITY_KEYS)[number]
  | (typeof FLEET_KEYS)[number]
  | (typeof DRIVERS_KEYS)[number]
  | (typeof LOGISTICS_KEYS)[number]
  | (typeof PRICING_KEYS)[number]
  | (typeof ALERTS_KEYS)[number]
  | (typeof MESSAGES_KEYS)[number]
  | (typeof SETTINGS_KEYS)[number]
  | (typeof B2B_KEYS)[number]
  | (typeof LANGUAGE_KEYS)[number];
